<template>
  <app-layout middled class="activeWorkoutLayout">

    <template slot="top">
      <div class="workoutProgress">
        <template v-for="x in workout.sets">
          <div  class="trainingBar"
                v-for="trn in workout.trainings" 
                :class="progressStyle(x, trn)"> </div>
          <div class="breakBar" v-if="x < workout.sets"> </div>
        </template>
      </div>
    </template>


    <workout-finished v-if="workout.done" :workout="workout" :duration="duration"/> 

    <div id="activeWorkout" v-else>
      <div class="countDown" v-if="countdown">
        <span>{{countdown}}</span>
      </div>
    
      <div class="pause" v-if="pause">
        <h3 class="highlight">mach ne Pause!</h3>
        <br/>
        <img src="../../assets/images/pause.png" class="trainPic" />
        <div class="clearfix"></div>
        <br/>
        <p class="loud half-press">
          <strong class="highlight gray">{{ nicePause }}</strong>
        </p>
      </div>
    
      <div class="currentTraining" v-else>
        <p class="no-press shade">
          <span class="gray louder" v-if="training.reps">{{training.reps}}&times;</span>
          <span class="gray louder" v-if="training.time">{{training.time}} sek.</span>
        </p>
      
        <img :src="training.image_url" class="trainPic" />
        
        <p class="no-press shade">
          <span class="highlight">{{ training.name }}</span>
        </p>
        <div class="clearfix"></div>
      </div>
    </div>

    <template slot="bottom" class="activeWorkoutActions">
      <template v-if="workout.done">
        <v-btn color="error" block large outline @click="endWorkout">
          Workout schliessen
        </v-btn>
      </template>
      <template v-else>
        <v-btn color="warning" block large class="black--text" @click="stopRest" v-if="!excercise && pause">
          Pause beenden
        </v-btn>
        <v-btn color="success" block large outline v-if="!excercise && !pause" @click="startTraining">
          Workout starten
        </v-btn>
        <p v-if="excercise" class="loud 26  uh   uc7 half-press shade">
          Zeit: <strong class="highlight">{{ niceTime }}</strong>
        </p>
        <v-btn color="success" block large @click="finishTraining" v-if="excercise && excercising">
          Workout fertig
        </v-btn>
        <div class="brow align-items-center press" v-if="excercise && !excercising">
          <div class="col-4 lft"> 
            <v-btn fab @click="minusReps">
              -
            </v-btn>
            <v-btn fab @click="minusFiveReps">
              -<b>5</b>
            </v-btn>
          </div>
          <div class="col-4 highlight shade">
            <strong>{{ excercise.reps }}</strong> 
            <span class="grey--text">&times;</span>
          </div>
          <div class="col-4 rgt">
            <v-btn fab @click="plusFiveReps">
              +<b>5</b>
            </v-btn>
            <v-btn fab @click="plusReps">
              +
            </v-btn>
          </div>
        </div>
        <v-btn color="primary" block large @click="saveReps" v-if="excercise && !excercising">
          Abschliessen
        </v-btn>
      </template>
    </template>

  </app-layout>
</template>

<script>
import {mapGetters}     from 'vuex'
import FullBox          from '@/components/ui/FullBox.vue';
import UiSpinner        from '@/components/ui/Spinner';
import moment           from 'moment';

import workoutFinished  from '@/views/workouts/partials/workoutFinished'

export default {
  components: {
    FullBox,
    UiSpinner,
    workoutFinished
  },
  data(){
    return {
      timer:          null,
      countdown:      0,
      countFor:       1,
      alertSound:     new Audio('data:audio/wav;base64,UklGRl9vT19XQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YU' + Array(1e3).join(123)),
      volume:         0.25,
      excercise:      null,
      time:           null,
      direction:      null,
      countInterval:  null,
      clockTimer:     null,
      restTimer:      null,
      excercising:    false,
      pause:          false,
      pauseTime:      0
    }
  },
  mounted(){
    this.countFor = this.currentUser.countdown
  },
  computed: {
    ...mapGetters({
      currentUser:    'currentUser',
      workout:        'activeWorkout',
      messages:       'getMessages'
    }),
    training() {
      return this.workout.trainings[this.workout.currentTraining - 1]
    },
    niceTime() {
      return this.formatTimes( this.time )
    },
    nicePause() {
      return this.formatTimes( this.pauseTime )
    },
    duration() {
      if (this.workout.starts_at && this.workout.finished_at) {
        console.log("duration", this.workout.starts_at, this.workout.finished_at)
        let that = moment( String(this.workout.finished_at) ).format("X") - moment( String(this.workout.starts_at) ).format("X")
        
        // console.log("duration", moment( String(this.workout.starts_at) ).format("X"), this.workout.finished_at.format("X"), that)
        return this.formatTimes( that )
      }
    }
  },
  methods: {
    progressStyle(theSet, trng) {
      if ( this.workout.done || ( this.workout.currentSet > theSet || (this.workout.currentSet === theSet && trng.position < this.workout.currentTraining) ) ) {
        return 'done'
      } else if ( this.workout.currentSet === theSet && trng.position === this.workout.currentTraining ) {
        return 'current'
      } else {
        return ''
      }
    },
    formatTimes( time ){
      let txt = ""
      if (time < 0) {
        let time = time + -1
        let txt = "+ "
      }
      let hrs = parseInt(time / 3600)
      let mins = parseInt((time - hrs * 3600) / 60)
      let seks = time - mins * 60 - hrs * 3600
      if (hrs > 0) { txt +=  hrs + ':' }
      txt += mins + ':' + (seks < 10 ? '0' + seks : seks)
      return txt
    },
    beep() {
      this.alertSound.volume = this.volume
      this.alertSound.play()
    },
    startTraining() {
      this.countdown = this.countFor
      this.startTimer(this.countdown)
      this.excercising = true
    },
    startTimer( countdown ) {
      if ( countdown > 0 ) {
        this.timer = setTimeout(() => {
          this.countdown = this.countdown - 1;
          this.startTimer( this.countdown )
        }, 1000);
      } else {
        this.timer = null
        this.beep()
        this.startExcercise()
      }
    },
    startExcercise() {
      this.excercise = {
        position:           this.training.position,
        starts_at:          moment(),
        training_id:        this.training.training_id,
        plan_training_id:   this.training.plan_training_id,
        workout_id:         this.workout.id,
        set:                this.workout.currentSet,
        reps:               this.training.reps || 1
      }
      if (this.training.time) {
        this.time = parseInt( this.training.time )
        this.direction = "down"
      } else {
        this.time = 0
        this.direction = "up"
      }
      this.clockTimer = setInterval(() => {
        if (this.direction === "up") {
          this.time += 1
        } else {
          this.time -= 1
        }
        if (this.direction === "down" && this.time === 0) {
          clearInterval(this.clockTimer)
          this.beep()
          // timeOverWorkout()
        }
      }, 1000)
    },
    finishTraining() {
      this.excercise['ends_at'] = moment()
      this.excercising = false
      if (this.clockTimer) { clearInterval(this.clockTimer) }
    },
    plusReps() {
      this.excercise.reps += 1
    },
    plusFiveReps() {
      this.excercise.reps += 5
    },
    minusReps() {
      if (this.excercise.reps > 0) {
        this.excercise.reps -= 1
      }
    },
    minusFiveReps() {
      this.excercise.reps -= 5
      if (this.excercise.reps < 0) {
        this.excercise.reps = 0
      }
    },
    saveReps() {
      // this.workout.excercises.push( this.excercise )
      this.$store.dispatch('addExcercise', this.excercise)
      this.excercise = null
      this.nextOne()
    },
    nextOne() {
      if (this.workout.currentTraining < this.workout.trainings.length) {
        this.$store.dispatch('setCurrentTraining', this.workout.currentTraining + 1)
      } else {
        if (this.workout.currentSet < this.workout.sets) {
          this.setRest()
          this.$store.dispatch('setCurrentSet', this.workout.currentSet + 1)
          this.$store.dispatch('setCurrentTraining', 1)
        } else {
          this.$store.dispatch('finishWorkout')
        }
      }
    },
    setRest() {
      this.pause = true
      this.pauseTime = this.workout.plan.set_rest || 120
      this.restTimer = setInterval(() => {
        this.pauseTime -= 1
        if (this.pauseTime === 0) {
          clearInterval(this.restTimer)
          this.pause = false
          this.beep()
        }
      }, 1000)
    },
    stopRest() {
      if (this.restTimer) { clearInterval(this.restTimer) }
      this.pauseTime = 0
      this.pause = false
    },
    
    endWorkout() {
      // this.workout = null
      this.$router.push('/')
      this.$store.dispatch('unsetActiveWorkout')
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
.countDown {
  // display: block; 
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0; bottom: 0;
  left: 0; right: 0;
  background: rgba(0,0,0,.65);
  z-index: 999;
  color: #fff;
  font-weight: bold;
  
  span {
    display: block;
    border: solid 7px rgba(255,255,255,.55);
    border-radius: 100%;
    width:        10rem;
    height:       10rem;
    line-height:  10rem;
    font-size:    6rem;
    text-shadow:  0 1px 1px #000, 1px 1px 1px #000, 1px 0 1px #000, 0 0 1px #000;
    box-shadow:   0 1px 1px #000;
  }
}

.trainPic {
  width: 70%;
  max-width: 300px;
}


.shade {
  text-shadow:  0   0   3px #fff,
                1px 1px 3px #fff,
                1px 0   3px #fff,
                0   1px 3px #fff !important;
}
.highlight {
  font-weight: bold; 
}


.workoutProgress {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  
  // position: absolute;
  // // top: 110px; 
  // top: 60px;
  // left: 0px; right: 0px;
  padding: 6px 10px 3px;
  background: #fff;
  border-bottom: solid 1px #ddd;
  
  .trainingBar, .breakBar {
    display: block;
    height: 13px;
  }
  
  .trainingBar {
    background: rgba(0,0,0,.12);
    border: solid 1px #f3f2f2;
    border-radius: 8px;
    flex-grow: 2;
    &.done {
      background: rgba(40, 167, 69, 0.5);
    }
    &.current {
      // background: rgba(255, 193, 7, 0.42);
      background: rgba(0,0,0,.42);
    }
  }
  .breakBar {
    background: transparent;
    flex-grow: 2;
  }
  
  
}


.darkApp, .application.theme--dark {

  .shade {
    color: #ccc;
    text-shadow:  0   0   3px #000,
                  1px 1px 3px #000,
                  1px 0   3px #000,
                  0   1px 3px #000 !important;
  }
  .gray { color: #ccc; }
  .highlight {
    font-weight: bold; 
    color: #FFA000 !important;
  }

  .workoutProgress {
    background: #222;
    border-bottom: solid 1px #000;
    .trainingBar {
      border: solid 1px #000;
      background: rgba(153,153,153,.13);
      &.done {
        background: rgba(40, 167, 69, 0.55);
      }
      &.current {
        background: rgba(153,153,153,.62);
      }
    }
  }
}

.highlight, .louder { font-size: 1.1em; }

.activeWorkoutLayout {
  .highlight, .louder { font-size: 2em; }
}
// sm
@media (min-width: 600px) {
  .highlight, .louder { font-size: 1.3em; }
}
// md
@media (min-width: 960px) {
  .highlight, .louder { font-size: 2em; }
}
// lg
@media (min-width: 1264px) {
  // ..
}

</style>